(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('membership-fee', {
            parent: 'entity',
            url: '/membership-fee?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.membershipFee.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/membership-fee/membership-fees.html',
                    controller: 'MembershipFeeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('membershipFee');
                    $translatePartialLoader.addPart('enumMembershipFeeType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('membership-fee-detail', {
            parent: 'membership-fee',
            url: '/membership-fee/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.membershipFee.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/membership-fee/membership-fee-detail.html',
                    controller: 'MembershipFeeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('membershipFee');
                    $translatePartialLoader.addPart('enumMembershipFeeType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MembershipFee', function($stateParams, MembershipFee) {
                    return MembershipFee.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'membership-fee',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('membership-fee-detail.edit', {
            parent: 'membership-fee-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membership-fee/membership-fee-dialog.html',
                    controller: 'MembershipFeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MembershipFee', function(MembershipFee) {
                            return MembershipFee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('membership-fee.new', {
            parent: 'membership-fee',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membership-fee/membership-fee-dialog.html',
                    controller: 'MembershipFeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                year: null,
                                price: null,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('membership-fee', null, { reload: 'membership-fee' });
                }, function() {
                    $state.go('membership-fee');
                });
            }]
        })
        .state('membership-fee.edit', {
            parent: 'membership-fee',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membership-fee/membership-fee-dialog.html',
                    controller: 'MembershipFeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MembershipFee', function(MembershipFee) {
                            return MembershipFee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('membership-fee', null, { reload: 'membership-fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('membership-fee.delete', {
            parent: 'membership-fee',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membership-fee/membership-fee-delete-dialog.html',
                    controller: 'MembershipFeeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MembershipFee', function(MembershipFee) {
                            return MembershipFee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('membership-fee', null, { reload: 'membership-fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
